import React, { useState, useEffect } from 'react';
import { api } from '../../api/api';

interface UserAsset {
  id: number;
  name: string;
  description: string;
  image_path: string;
  price: number;
  category: string;
}

interface SellAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SellAssetModal = ({ isOpen, onClose }: SellAssetModalProps) => {
  const [userAssets, setUserAssets] = useState<UserAsset[]>([]);
  const [selectedAsset, setSelectedAsset] = useState('');
  const [price, setPrice] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const fetchUserAssets = async () => {
        try {
          const response = await api.get('/api/user/assets'); // This endpoint needs to be created
          setUserAssets(response.data);
        } catch (error) {
          console.error('Failed to fetch user assets', error);
        }
      };
      fetchUserAssets();
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log({ selectedAsset, price, currency });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 font-gothic">
      <div className="bg-black border-2 border-yellow-400 rounded-lg p-8 w-full max-w-md m-4">
        <h2 className="text-2xl font-bold text-yellow-400 mb-4">Sell Asset</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="asset" className="block text-yellow-400 mb-2">Select Asset</label>
            <select
              id="asset"
              value={selectedAsset}
              onChange={(e) => setSelectedAsset(e.target.value)}
              className="w-full p-2 rounded-lg bg-gray-800 text-yellow-400 border border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            >
              <option value="" disabled>Select an asset</option>
              {userAssets.map((asset) => (
                <option key={asset.id} value={asset.id}>{asset.name}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor="price" className="block text-yellow-400 mb-2">Price</label>
            <div className="flex">
              <input
                type="number"
                id="price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="w-full p-2 rounded-l-lg bg-gray-800 text-yellow-400 border border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
              <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                className="p-2 rounded-r-lg bg-gray-800 text-yellow-400 border border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              >
                <option value="USD">USD</option>
                <option value="ETH">ETH</option>
              </select>
            </div>
          </div>
          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                className="form-checkbox h-5 w-5 text-yellow-400 bg-gray-800 border-yellow-400 focus:ring-yellow-400"
              />
              <span className="ml-2 text-yellow-400">I understand and agree to the terms of service.</span>
            </label>
          </div>
          <div className="flex justify-end">
            <button type="button" onClick={onClose} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-lg mr-2">
              Cancel
            </button>
            <button type="submit" className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 px-4 rounded-lg" disabled={!consent || !price}>
              Sell
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SellAssetModal;
